import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../../models/chips-and-fields';

@Component({
  selector: 'app-checkbox-standard',
  templateUrl: './checkboxStandard.component.html',
  styleUrls: ['./checkboxStandard.component.css']
})
export class CheckboxStandardComponent implements OnInit {

  @Input() public field: Field;
  @Input() public parentFormGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
